<template>
  <div class="page-container">
    <PageHeader title="用户统计" show-breadcrumb />

    <!-- 搜索面板：按用户ID筛选 -->
    <SearchPanel>
      <el-input v-model.trim="query.zauId" placeholder="用户ID" clearable size="small" @keyup.enter.native="handleSearch" />
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="PK用户统计列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column label="用户" min-width="140" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.zauName || ('用户' + row.zauId) }}</template>
        </el-table-column>
        <el-table-column prop="pusPkNums" label="PK场次" min-width="100" align="center" />
        <el-table-column label="总积分" min-width="100" align="center">
          <template slot-scope="{ row }"><span style="color:#d69e2e;font-weight:700">{{ row.pusPointsTotal }}</span></template>
        </el-table-column>
        <el-table-column label="胜率" min-width="170" align="center">
          <template slot-scope="{ row }">
            <el-progress :percentage="Number(row.pusPkWinRate) || 0" :stroke-width="10" :format="p => p + '%'" style="max-width:150px;margin:0 auto" />
          </template>
        </el-table-column>
        <el-table-column label="最高连胜" min-width="100" align="center">
          <template slot-scope="{ row }"><el-tag size="small" type="danger">{{ row.pusWinningStreakMax }}</el-tag></template>
        </el-table-column>
        <el-table-column label="当前连胜" min-width="100" align="center">
          <template slot-scope="{ row }"><el-tag size="small" type="warning">{{ row.pusWinningStreakNow }}</el-tag></template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" style="color:#409eff" @click="handleDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 用户统计详情 -->
    <el-dialog title="用户统计详情" :visible.sync="detailVisible" width="520px" v-dialog-drag-resize>
      <div v-loading="detailLoading" class="stat-detail">
        <template v-if="detail">
          <div class="stat-row"><span>用户</span><b>{{ detail.zauName || ('用户' + detail.zauId) }}</b></div>
          <div class="stat-row"><span>PK场次</span><b>{{ detail.pusPkNums }}</b></div>
          <div class="stat-row"><span>总积分</span><b>{{ detail.pusPointsTotal }}</b></div>
          <div class="stat-row"><span>胜率</span><b>{{ detail.pusPkWinRate }}%</b></div>
          <div class="stat-row"><span>最高连胜</span><b>{{ detail.pusWinningStreakMax }}</b></div>
          <div class="stat-row"><span>当前连胜</span><b>{{ detail.pusWinningStreakNow }}</b></div>
        </template>
      </div>
      <div slot="footer"><el-button size="small" @click="detailVisible = false">关闭</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getPkqUserStatisticsList, getPkqUserStatisticsByZauId } from '@/api/api'

export default {
  name: 'PkqUserStatistics',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      query: { zauId: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      detailVisible: false,
      detailLoading: false,
      detail: null
    }
  },
  created () { this.fetchList() },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        const res = await getPkqUserStatisticsList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { zauId: '' }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    async handleDetail (row) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      try {
        const res = await getPkqUserStatisticsByZauId({ pusId: row.pusId })
        this.detail = res.data || null
      } catch (e) { this.detail = null } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-detail { min-height: 120px; }
.stat-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 12px 16px; border-bottom: 1px dashed #e5e7eb;
  font-size: 14px;
  span { color: #64748b; }
  b { color: #1e293b; font-size: 15px; }
}
</style>
